import React from 'react';
import {
  Navigate,
  useLocation,
} from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-900 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-slate-600">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (
    user.must_change_password &&
    location.pathname !== '/alterar-senha'
  ) {
    return (
      <Navigate
        to="/alterar-senha"
        replace
      />
    );
  }

  if (
    !user.must_change_password &&
    location.pathname === '/alterar-senha'
  ) {
    return (
      <Navigate
        to="/dashboard"
        replace
      />
    );
  }

  return children;
};
